import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-community";
import { Fragment } from "react";
import { TooltipText } from "@/components/common/TooltipText";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import {
  formatSecondsToFormattedDate,
  oneDayInSeconds,
} from "@/store/kubernetes-live-usage-mgmt/thunks/resources/utils/helpers/kubernetes-reosurce-details-drawer-data/generateKubernetesResourceDetailsHeaderChipsData";

export const k8sAgeColumnDef: ColDef = {
  field: "resource.age_in_seconds",
  headerName: "Age",
  valueGetter: ({ data }: ValueGetterParams) => {
    const age = data?.resource?.age_in_seconds;

    if (typeof age !== "number") {
      return "-";
    }

    return formatSecondsToFormattedDate(age);
  },
  cellRenderer: ({ data }: ICellRendererParams) => {
    const age = data?.resource?.age_in_seconds;

    if (typeof age !== "number") {
      return <Fragment>-</Fragment>;
    }

    if (age >= oneDayInSeconds * 30) {
      return (
        <TooltipText tooltipTitle={formatSecondsToDays(age)} variant="body2">
          {formatSecondsToFormattedDate(age)}
        </TooltipText>
      );
    }

    return (
      <TypographyWithTooltip
        title={formatSecondsToFormattedDate(age)}
        variant="body2"
      />
    );
  },
};

const formatSecondsToDays = (seconds: number): string => {
  return `${Math.floor(seconds / oneDayInSeconds)
    .toFixed(2)
    .replace(/\.00$/, "")}d`;
};
